<div class="well">
    <h5 [ngClass]="{'required-input': isLocalityRequired()}">Localities</h5>
    <div class="row">
        @for (locality of model.localities; track locality; let i = $index) {
            <div
                ng-repeat="locality in $ctrl.model.localities"
                class="col-xs-4">
                <div
                    class="input-group"
                    [ngClass]="{'has-error': (locality.dirty || submitted) && (checkLocalityName(i) || isLocalityNameInvalid(i))}">
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-edit"></i>
                    </span>
                    <input
                        #locality="ngModel"
                        type="text"
                        name="locality{{i}}"
                        id="locality{{i}}"
                        class="form-control"
                        autocomplete="off"
                        [ngModel]="locality.localityName"
                        [nlrTypehead]="localityNameSearch"
                        (ngModelChange)="onLocalityNameChange($event, i)"
                        (itemSelected)="localitySelected($event, i)"
                        placeholder="Enter to search"
                        typeahead-on-select="$ctrl.onSelectLocality($index)"
                        typeahead-editable="false"
                        required />
                    <span class="input-group-addon">
                        <i class="nlrp-icon nlrp-icon-search"></i>
                    </span>
                    <span class="input-group-addon">
                        <i
                            class="nlrp-icon nlrp-icon-add"
                            (click)="addLocality(i)"
                            title="Add locality"
                            tabindex="0"></i>
                    </span>
                    <span class="input-group-addon">
                        <i
                            class="nlrp-icon nlrp-icon-remove"
                            (click)="removeLocality(i)"
                            title="Remove locality"
                            tabindex="0"></i>
                    </span>
                </div>
            </div>
        }
    </div>
</div>
